import { AppBar, Divider, IconButton, Menu, MenuItem, Tab, Tabs, Toolbar, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../../assets/images/Chp_Logo.png';
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import PhoneIcon from '@mui/icons-material/Phone';
import TableChartIcon from '@mui/icons-material/TableChart';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import BuildIcon from '@mui/icons-material/Build';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import BusinessIcon from '@mui/icons-material/Business';
import MapIcon from '@mui/icons-material/Map';
import WorkIcon from '@mui/icons-material/Work';
import HelpIcon from '@mui/icons-material/Help';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import TuneIcon from '@mui/icons-material/Tune';
import Authorization from '../../../utils/Authorization';
import { useAppDispatch } from '../../../store/store';
import { logout } from '../../../store/authentication.slice';
import { FrontendBuildMenuFooter } from '../FrontendBuildMenuFooter';

const AdminNavbar = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const authData = new Authorization();

    const routes = location.pathname.split('/');
    const value = `/${routes[1]}/${routes[2]}`;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [envText, setEnvText] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const logoutHandler = () => {
        dispatch(logout());
        navigate('/', { replace: true });
    };

    useEffect(() => {
        var auth = new Authorization();
        var env = auth.getEnv();
        if (env !== 'Production') {
            setEnvText(env);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            {location.pathname.indexOf('admin') > -1 && authData.IsAdmin ? (
                <header>
                    <AppBar color="default" style={{ position: 'sticky', top: 0 }}>
                        <Toolbar>
                            <Typography className="env-text env-text-small" align="center">
                                {envText}
                            </Typography>
                            <img src={logo} alt="logo" />
                            <Tabs
                                sx={{
                                    marginX: 'auto',
                                    [`& .MuiTab-root`]: { ':hover': { textDecoration: 'none' } },
                                    [`& .MuiTab-root.Mui-selected`]: { color: '#1976d2', background: 'rgba(25, 118, 210, 0.07)' },
                                }}
                                textColor="inherit"
                                variant="scrollable"
                                scrollButtons="auto"
                                value={value}
                                indicatorColor="primary"
                                TabIndicatorProps={{ style: { height: '5px' } }}
                            >
                                <Tab label="Providers" icon={<PersonIcon />} component={NavLink} value={'/admin/providers'} to="providers" />
                                <Tab label="Members" icon={<GroupsIcon />} component={NavLink} value={'/admin/members'} to="members" />
                                <Tab label="Onboarding" icon={<PhoneIcon />} component={NavLink} value={'/admin/onboarding'} to="onboarding" />
                                <Tab label="Scheduling" icon={<CalendarMonthIcon />} component={NavLink} value={'/admin/scheduling'} to="scheduling" />
                                <Tab label="Roles" icon={<WorkIcon />} component={NavLink} value={'/admin/roles'} to="roles" />
                                <Tab label="CPT Codes" icon={<WorkIcon />} component={NavLink} value={'/admin/cptcodes'} to="cptcodes" />
                                <Tab label="Regions" icon={<MapIcon />} component={NavLink} value={'/admin/regions'} to="regions" />
                                <Tab label="Facilities" icon={<BusinessIcon />} component={NavLink} value={'/admin/facilities'} to="facilities" />
                                <Tab label="AI Management" icon={<SmartToyIcon />} component={NavLink} value={'/admin/ai-management'} to="ai-management" />
                                <Tab label="Data Corrections" icon={<BuildIcon />} component={NavLink} value={'/admin/datacorrections'} to="datacorrections" />
                                <Tab label="Health Plan" icon={<MedicalInformationIcon />} component={NavLink} value={'/admin/healthplan'} to="healthplan" />
                                <Tab label="Metric Goals" icon={<TableChartIcon />} component={NavLink} value={'/admin/metricgoals'} to="metricgoals" />
                                <Tab
                                    label="Request Point Settings"
                                    icon={<TuneIcon />}
                                    component={NavLink}
                                    value={'/admin/request-point-settings'}
                                    to="request-point-settings"
                                />
                                <Tab
                                    label="Help & Resources"
                                    icon={<HelpIcon />}
                                    component={NavLink}
                                    value={'/admin/adminhelpresources'}
                                    to="adminhelpresources"
                                />
                            </Tabs>
                            <IconButton onClick={handleClick} sx={{ marginLeft: 2, borderRadius: 0, background: 'white' }}>
                                <ArrowDropDownIcon />
                            </IconButton>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        navigate('help&resources');
                                        handleClose();
                                    }}
                                >
                                    Help & Resources
                                </MenuItem>
                                {authData.IsAdmin && (
                                    <MenuItem
                                        onClick={() => {
                                            navigate(`/provider/metricsummary`);
                                            handleClose();
                                        }}
                                    >
                                        Switch to Provider
                                    </MenuItem>
                                )}
                                <Divider />
                                <MenuItem onClick={logoutHandler}>Logout</MenuItem>
                                <FrontendBuildMenuFooter />
                            </Menu>
                        </Toolbar>
                    </AppBar>
                    <Outlet />
                </header>
            ) : null}
        </>
    );
};

export default AdminNavbar;
